jQuery(function(){

    jQuery('body').on('click', '.footer__terms-conditions-link', function(e){
        e.preventDefault();

        var $container = jQuery(this).parent();
        jQuery(this).toggleClass('footer__terms-conditions-link--open');

        var $terms = $container.next('.footer__terms-conditions-container');

        $terms.toggleClass('footer__terms-conditions-container--open');
        if (jQuery(this).hasClass("footer__terms-conditions-link--open")){
            jQuery(this).attr("aria-expanded", "true");
        }
        else{
            jQuery(this).attr("aria-expanded", "false");
        }
        return false;
    });

    jQuery('body').on('click', '.footer__back-to-top', function(e){
        e.preventDefault();
        var scrollcontainer = document.querySelector(".scroll-container");
        jQuery(this).blur();
        jQuery("html, body").animate({ scrollTop: 0 }, "medium");
        scrollcontainer.tabIndex = 0;
        scrollcontainer.focus();
        //If we don't remove it Safari acts weired with VO
        setTimeout(function(){ scrollcontainer.removeAttribute("tabindex") }, 500);
    });

    jQuery('body').on('click', '.footer__menu-heading-link', function(e){
        e.preventDefault();
        var $this = jQuery(this);

        $this.toggleClass('footer__menu-heading-link--open');
        var $container = $this.parent('.footer__menu-heading--mobile');
        var $menu = $container.next('.footer__menuitems');

        $menu.toggleClass('footer__menuitems--open');


    });

});